import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import Transmogrifier from "./Transmogrifier";
import GraduatedChampSelection from "../GraduatedChampSelection";
import { useLogEvent } from "../../contexts/Analytics";

export default function Graduate({ champ, isOpen, onChampSelected }) {
  const award = get(champ, "graduationCertificate");
  const jwPlayerId = get(champ, "phaseTransition.video.jwPlayerId");

  const [openDialog, setOpenDialog] = React.useState(false);
  const { logEvent } = useLogEvent({
    event: "Champ Achievement Printed",
    options: { referrer: () => {} },
  });

  if (!jwPlayerId) {
    return null;
  }

  return (
    <>
      <Transmogrifier
        title={`You maxed out ${champ.name}`}
        award={award}
        jwPlayerId={jwPlayerId}
        isOpen={isOpen}
        action="Choose a new champ"
        onActionClick={() => setOpenDialog(true)}
        onPrintAward={() => logEvent({ champName: champ.name, level: "Max" })}
      />

      {openDialog && (
        <GraduatedChampSelection
          champ={champ}
          onChampSelected={onChampSelected}
        />
      )}
    </>
  );
}

Graduate.propTypes = {
  champ: PropTypes.shape({
    name: PropTypes.string.isRequired,
    levelUpCertificate2: PropTypes.string.isRequired,
    levelUpCertificate3: PropTypes.string.isRequired,
    levelUpCertificate4: PropTypes.string.isRequired,
    graduationCertificate: PropTypes.string.isRequired,
  }),
  isOpen: Transmogrifier.propTypes.isOpen,
  onChampSelected: PropTypes.func.isRequired,
};
